import config from '@app/config'

import {
  CULTURE_TO_DOMAINS,
  type PortalEnvironment,
} from '@app/utils/regional/constants'

const normalizeDomain = (value: string): string =>
  value.replace(/^https?:\/\//u, '').toLowerCase()

export const getAllowedDomains = (): Set<string> => {
  const env = (config.environment ?? 'development') as PortalEnvironment
  const environmentDomains =
    CULTURE_TO_DOMAINS[env] ?? CULTURE_TO_DOMAINS.development

  return new Set<string>(
    Object.values(environmentDomains).map((domain) => normalizeDomain(domain))
  )
}
